<script setup>
import { onMounted, watch } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { useRouter } from 'vue-router';
import { frontendURL } from 'dashboard/helper/URLHelper.js';

defineProps({
  keepAlive: { type: Boolean, default: true },
});

const store = useStore();
const router = useRouter();
const { currentAccount, accountId } = useAccount();

watch(
  currentAccount,
  () => {
    const isInactive =
      currentAccount.value?.settings?.sales_assist_enabled === 'inactive';
    if (isInactive) {
      router.push(frontendURL(`accounts/${accountId.value}/dashboard`));
    }
  },
  { deep: true, immediate: true }
);

onMounted(() => {
  store.dispatch('inboxes/get');
  store.dispatch('agents/get');
});
</script>

<template>
  <div class="flex flex-1 h-full m-0 overflow-auto bg-n-background">
    <router-view v-slot="{ Component }">
      <keep-alive v-if="keepAlive">
        <component :is="Component" />
      </keep-alive>
      <component :is="Component" v-else />
    </router-view>
  </div>
</template>
